import { api } from '..';

export const changePreset = async ({
  id,
  name,
}: {
  id: number;
  name: string;
}) => {
  const data = await api.put(`/api/v1/general/user/preset/?pk=${id}`, {
    body: {
      name,
    },
  });
  return data;
};
